import { render, staticRenderFns } from "./RequestProposedEmployees.vue?vue&type=template&id=3797d5be&scoped=true&"
import script from "./RequestProposedEmployees.vue?vue&type=script&lang=js&"
export * from "./RequestProposedEmployees.vue?vue&type=script&lang=js&"
import style0 from "./RequestProposedEmployees.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RequestProposedEmployees.vue?vue&type=style&index=1&id=3797d5be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3797d5be",
  null
  
)

export default component.exports
import {QCard,QToolbar,QToolbarTitle,QTable,QTr,QTh,QTd,QInnerLoading,QSpinnerGears,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign({QCard,QToolbar,QToolbarTitle,QTable,QTr,QTh,QTd,QInnerLoading,QSpinnerGears,QCardActions,QBtn}, component.options.components || {})
